<template>
  <b-autocomplete
    :id="dataE2e"
    :model-value="value"
    :data="data"
    :placeholder="placeholder"
    :icon="icon"
    :icon-pack="iconPack"
    :loading="loading"
    :disabled="disabled"
    :field="field"
    @update:model-value="onInput"
    @select="onSelect"
  />
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'AutocompleteView',
  emits: ['input', 'select'],
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    data: {
      type: Array
    },
    field: {
      type: String,
      default: 'value'
    },
    loading: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    icon: {
      type: String
    },
    iconPack: {
      type: String,
      default: 'cls'
    },
    disabled: {
      type: Boolean
    },
    dataE2e: {
      type: String
    }
  },
  methods: {
    onInput(...args) {
      this.$emit('input', ...args);
    },
    onSelect(...args) {
      this.$emit('select', ...args);
    }
  }
};
</script>
